import React from "react";
import { Link } from "react-router-dom";

export default function MedicalNotFoundPage() {
  return (
    <section className="bg-[#f8f8f4] py-20">
      <div className="container-app mx-auto max-w-4xl px-4 text-center">
        <h1 className="text-3xl font-bold text-gray-900">Seite nicht gefunden</h1>
        <p className="mt-4 text-gray-700">
          Die angeforderte Seite existiert nicht.
        </p>
        <Link
          to="/medical"
          className="mt-6 inline-block rounded-full border border-black bg-white px-5 py-2.5 text-sm font-medium text-black transition hover:bg-black hover:text-white"
        >
          Zur Startseite
        </Link>
      </div>
    </section>
  );
}
